import SelectLocationDetailsModal from './SelectLocationDetailsModal'

export default SelectLocationDetailsModal
